export const replaceNewlinesWithBreaks = (text: string) => {
  return text.replaceAll('\r\n', '<br>').replaceAll('\n', '<br>');
};
